import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

import trEn from './translations/en.json';
import trFi from './translations/fi.json';

const resources = {
    en: { translation: trEn },
    fi: { translation: trFi },
};

const availableLanguages = ['en', 'fi'];
const detection_opts = {
    order: ['navigator'],
};

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        detection: detection_opts,
        resources,
        debug: false,
        whitelist: availableLanguages,
        fallbackLng: 'en',

        keySeparator: false,
        interpolation: { escapeValue: false },
        react: { wait: true },
    });

i18n.changeLanguage();

export default i18n;
